import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {OktaAuthService} from '../app.service';

@Component({
  selector: 'app-not-assigned',
  templateUrl: './not-assigned.component.html',
  styleUrls: ['./not-assigned.component.scss']
})
export class NotAssignedComponent implements OnInit {

  constructor(private router: Router, private modalService: NgbModal, private auth: OktaAuthService, ) {
  }

  ngOnInit() {
  }

  logout() {
    this.auth.logout();
  }
}
